import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  GuardResult,
  CanActivateFn,
} from "@angular/router";
import { InitialiseService } from "src/app/services";

export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<GuardResult> => {
  const router = inject(Router);
  const init = inject(InitialiseService);

  try {
    // 1 - is user logged in?
    const loggedIn = await init.user();
    if (!loggedIn) {
      throw new Error("User not authenticated.");
    }

    // 3 - is the current route valid?
    const routeGuid = route.params["tenantid"];

    // 4 - is the current tenant loaded?
    const resultRouteGuid = await init.route(routeGuid);

    if (routeGuid !== resultRouteGuid) {
      return router.createUrlTree(["/", resultRouteGuid, "projects"]);
    }

    return true;
  } catch (ex) {
    // assertions failed, logout and return to /login
    return router.createUrlTree(["/", "login"]);
  }
};
